// @vendors
import { Link } from 'react-router-dom'
import { Button } from 'antd'

// @styles
import './styles.scss'

// @images
import wariningImage from 'assets/images/warning.png'
import errorClouds from 'assets/images/error-clouds.png'
import shipImage from 'assets/images/ship.png'
import notFound from 'assets/images/not-found.png'
import Context from 'context/appContext'
import { useContext } from 'react'

export default function AlertMessage({ info }) {
    const { product,productAuto } = useContext(Context);

    const alertType = {
        warning: {
            image: wariningImage,
            title: 'Algo salió mal...',
            description: 'Por favor vuelve a intentarlo',
            action: <Button onClick={() => window.location.reload(false)} className='ant-btn-transparent'>Aceptar</Button>
        },
        error: {
            image: errorClouds,
            title: 'Algo salió mal...',
            description: 'Por favor vuelve a intentarlo',
            action: <Button onClick={() => window.location.reload(false)} className='ant-btn-transparent'>Aceptar</Button>
        },
        info: {
            image: shipImage,
            title: 'Agradecemos tu confianza',
            description: 'Desafortunadamente no contamos con un seguro de vida que se adecue a tu perfil. Te invitamos a conocer otras ofertas de seguro que tenemos para ti.',
            action: <Link to="/" onClick={() => window.location.reload(false)} className='ant-btn ant-btn-transparent'>Inicio</Link>
        },
        notFound: {
            image: notFound,
            title: '404',
            description: 'Página no encontrada. Vuelve a la página anterior o al inicio',
            action: <Link to="/" onClick={() => window.location.replace(`/${productAuto}/`)} className='ant-btn ant-btn-transparent'>Volver a inicio</Link>
        }
    }

    return (
        <div
            className='alert-message'
            style={{
                backgroundImage: `url('${info && alertType[info.type].image}')`
            }}
        >
            <h2 className='alert-message__title'>
                {info && info.title ? info.title : alertType[info.type].title}
            </h2>
            <p className='alert-message__parag'>
                {info && info.description ? info.description : alertType[info.type].description}
            </p>
            {alertType[info && info.type].action}
        </div>
    )
}